var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11062e-08 4.29088C5.29381e-08 4.13708 0.0600238 3.98329 0.179819 3.86603L3.9514 0.176048C4.19132 -0.0586827 4.58031 -0.0586827 4.82013 0.176048C5.05996 0.410685 5.05996 0.791185 4.82013 1.02593L1.48283 4.29088L4.82002 7.55584C5.05984 7.79057 5.05984 8.17104 4.82002 8.40565C4.58019 8.6405 4.19121 8.6405 3.95129 8.40565L0.179702 4.71573C0.0598875 4.59841 4.9275e-08 4.44463 5.11062e-08 4.29088Z",
    fill: "#484964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.ccaab67edc403bea755cbbf08d9cd8d1.svg";
export { ForwardRef as ReactComponent };